import { render } from "./LinksInterest.vue?vue&type=template&id=afa1b818&scoped=true"
import script from "./LinksInterest.vue?vue&type=script&lang=js"
export * from "./LinksInterest.vue?vue&type=script&lang=js"

import "./LinksInterest.vue?vue&type=style&index=0&id=afa1b818&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa1b818"]])

export default __exports__